'use client'

import type { ReactNode } from 'react'
import { RowSurfaceProvider } from '@/deskUiSkeletons/rowTemplates/RowSurfaceContext'
import type { RowSurface } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'
import { SubRow } from '@/deskUiSkeletons/subs/SubRow'
import { showQuickReplyModal } from '@/deskUiSkeletons/Shared/QuickReplyModal'
import { rowVariantRegistry } from '@/mailboxDesk/rowTemplates/RowTemplateRegistry'
import { nestedTemplateVariant } from '@/mailboxDesk/rowTemplates/RowTemplateConfig'
import { rowSkin } from '@/mailboxDesk/rowTemplates/RowTemplateSkin'

// Mailbox wiring for the shared row skeleton: the surface leaves the skeleton
// reads through the RowSurface seam (25_SHARED_DESKUI_SKELETON.md §5).

const mailboxRowSurface: RowSurface = {
  SubRow,
  showQuickReplyModal,
  variants: rowVariantRegistry,
  config: { nestedTemplateVariant },
  skin: rowSkin,
}

export function MailboxRowSurfaceProvider({ children }: { children: ReactNode }) {
  return <RowSurfaceProvider value={mailboxRowSurface}>{children}</RowSurfaceProvider>
}
